export type StatComparison = {
    value: number
    format: 'percent' | 'absolute'
}

/** Day-over-day change for dashboard stat cards. */
export function computeDayOverDayComparison(current: number, previous: number): StatComparison {
    if (previous === 0) {
        return {
            value: current,
            format: current === 0 ? 'percent' : 'absolute',
        }
    }

    return {
        value: Math.round(((current - previous) / previous) * 100),
        format: 'percent',
    }
}
